<template>
  <b-row class="vh-100 text-center" align-v="center">
    <b-col v-bind:style="[colStyle]">
      <img src="../assets/img/logo.svg" />
      <h4>Te ayudamos a cumplir en todo lo relacionado con las leyes en materia aduanera para todas tus operaciones de comercio exterior.</h4>
      <br>
      <h4>Nuestro software te ayuda a procesar tu Data Stage y archivos de validación en el momento para que puedas obtener reportes y análisis de tus operaciones.</h4>
      <br>
      <h5>Contáctanos en <a href="mailto:info@eccompliance.com">info@eccompliance.com</a></h5>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      colStyle: {
        background: 'rgba(252, 252, 252, .8)',
        padding: '3px'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #0b6067;
}
a:hover {
  text-decoration: none;
  color: #0b6067;
}
</style>
